import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'page-tasks-toggle',
  templateUrl: 'page-tasks-toggle.html'
})

export class TasksPageToggle {
  public taskState: string = 'unscheduled';
  @Output() updateAction = new EventEmitter<string>();

  toggle(message){
    this.updateAction.emit(message.value);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/components/toggles/page-tasks-toggle.ts